import { EmptyListOf } from '@opengov/compose-app/immutable';

import { composeInitialState } from '@opengov/compose-app';

import { composeStateMachine } from '../module';

import { ErrorMessage } from './records';
import { IErrorMessage } from './types';

export const ErrorInitialState = composeInitialState({
  errors: EmptyListOf(ErrorMessage)
});

export const errorState = composeStateMachine('errors', ErrorInitialState, (compose) => ({
  record: compose.action((state: any, error: IErrorMessage<any>) =>
    state.update('errors', (errors) => errors.push(ErrorMessage(error).set('id', errors.size)))
  ),

  dismiss: compose.action((state, id: number) =>
    state.update('errors', (errors) => errors.filter((err) => err.id !== id))
  )
}));

export const {
  actions: errorActions,
  actionCreators: errorActionCreators,
  reducer: errorReducer,
  selector: errorSelector
} = errorState;
